import React, { Component } from 'react';
import ErrorFallback from './components/ErrorFallback/ErrorFallback';
import useCurrentUser from './hooks/useCurrentUser';
import sentryClient from './SentryProvider';

class ErrorBoundary extends Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    const { user, extraErrorData } = this.props;
    const {
      username, email, ID, userSlug,
    } = user || {};
    const link = window.location.toString();

    sentryClient
      .setExtras({ Link: link, 'React Error': info, ...extraErrorData })
      .setUser({
        username, email, id: ID, Type: userSlug,
      });

    sentryClient.report(error);
  }

  render() {
    const { children, ErrorUI = <ErrorFallback /> } = this.props;
    const { hasError } = this.state;
    if (hasError) return ErrorUI;
    return children;
  }
}

export default function ({ children, extraErrorData, ErrorUI }) {
  const { data } = useCurrentUser();

  return (
    <ErrorBoundary user={data} extraErrorData={extraErrorData} ErrorUI={ErrorUI}>
      {children}
    </ErrorBoundary>
  );
}
